import * as ACTION_TYPES from './Types';

const initialState = {
  lengths: {},
  message: '',
  error: null,
}

export const lengthReducer = (state = initialState, action) => {
  switch (action.type) {



    case ACTION_TYPES.GETLENGTH_SUCCESS:
      return {
        ...state,
        lengths: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETLENGTH_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }
    case ACTION_TYPES.ADDLENGTH_SUCCESS:
    case ACTION_TYPES.UPDATELENGTH_SUCCESS:
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDLENGTH_ERROR:
    case ACTION_TYPES.UPDATELENGTH_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
